import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { DxDataGridComponent, DxFilterBuilderComponent, DxTreeListComponent } from 'devextreme-angular';
import { custom } from 'devextreme/ui/dialog';
import { icon, latLng, Map, marker, tileLayer } from 'leaflet';
import * as moment from 'moment-jalaali';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { BytesPipe } from '../../../pipes/bytes.pipe';
import { DateformaterPipe } from '../../../pipes/dateformater.pipe';
import { GigPipe } from '../../../pipes/gig.pipe';
import { MinuteToTimeStructuredPipe } from '../../../pipes/minute-to-time-structured.pipe';
import { MoneyPipe } from '../../../pipes/money.pipe';
import { SecondToTimeStructuredPipe } from '../../../pipes/second-to-time-structured.pipe';
import { BaseService } from '../../../providers/base.service';
import { CommentFormComponent } from '../../home/comment-form/comment-form.component';
import { LocatorComponent } from '../../home/locator/locator.component';
import { BaseComponent } from '../base/base.component';
import * as XLSX from 'xlsx';
declare var $: any;

/** an api timestamp the column metadata never declared -- see cardDate() */
const ISO_DATE = /^\d{4}-\d{2}-\d{2}([T ]\d{2}:\d{2}(:\d{2})?(\.\d+)?(Z|[+-]\d{2}:?\d{2})?)?$/;
const ISO_DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

@Component({
  template: ''
}) export abstract class BaseListComponent extends BaseComponent implements OnInit, OnDestroy {
  constructor(
    public cookieService: CookieService,
    public activeModal: NgbModal,
    public titleService: Title,
    public translator: TranslateService,
    public service: BaseService,
  ) {
    super(service, translator, cookieService, titleService);
    this.amount = this.translator.instant('AMOUNT');
    this.allRoles = [
      { value: 'ADMIN', name: 'راهبر' },
      { value: 'AGENT_TDLTE', name: 'نماینده فروش ال تی ای' },
      { value: 'AGENT_WIRELESS', name: 'نماینده فروش وایرلس' },
      { value: 'ARCHIVE', name: 'بایگانی' },
      { value: 'CBO', name: 'مدیر کسب و کار' },
      { value: 'CDO', name: 'جانشین مدیرعامل' },
      { value: 'CEO', name: 'مدیرعامل' },
      { value: 'CONTRACT_OFC', name: 'کارشناس قرارداد' },
      { value: 'CRA', name: 'سازمان تنظیم مقررات' },
      { value: 'CR_MNG', name: 'مدیر ارتباط با مشتری' },
      { value: 'CR_OFC', name: 'کارشناس پشتیبانی فنی' },
      { value: 'CR_SUP', name: 'سرپرست پشتیبانی فنی' },
      { value: 'CTO', name: 'مدیر فنی' },
      { value: 'PASSIVE_SUP', name: 'سرپرست پسیو' },
      { value: 'CUSTOMER_CARE_MNG', name: 'مدیر امور مشتریان' },
      { value: 'CUSTOMER_CARE_OFC', name: 'کارشناس امور مشتریان' },
      { value: 'CUSTOMER_CARE_SUP', name: 'سرپرست امور مشتریان' },
      { value: 'DEDICATE_SALES_OFC', name: 'کارشناس فروش اختصاصی' },
      { value: 'DEDICATE_SALES_SUP', name: 'سرپرست فروش اختصاصی' },
      { value: 'FINANCE_ARCHIVE', name: 'آرشیو مالی' },
      { value: 'FINANCE_MNG', name: 'مدیر مالی' },
      { value: 'FINANCE_OFC', name: 'کارشناس مالی' },
      { value: 'FINANCE_SUP', name: 'سرپرست مالی' },
      { value: 'FLM_OFC', name: 'کارشناس عملیاتی - دکل کار' },
      { value: 'FLM_SUP', name: 'سرپرست دکل کاران' },
      { value: 'INSTALLER', name: 'نصاب' },
      { value: 'INSTALL_OFC', name: 'کارشناس نصب' },
      { value: 'INSTALL_SUP', name: 'سرپرست نصب' },
      { value: 'IP_CORE_MNG', name: 'مدیر IPCore' },
      { value: 'IP_CORE_SUP', name: 'سرپرست IPCore' },
      { value: 'IP_CORE_TX_OFC', name: 'کارشناس IPCore-Tx' },
      { value: 'MARKETING_MNG', name: 'مدیر بازاریابی' },
      { value: 'MARKETING_OFC', name: 'کارشناس بازاریابی' },
      { value: 'MARKETING_SUP', name: 'سرپرست بازاریابی' },
      { value: 'NOC_BO_OFC', name: 'کارشناس مرکزعملیات شبکه بک آفیس' },
      { value: 'NOC_FO_OFC', name: 'کارشناس مرکزعملیات شبکه فرانت آفیس' },
      { value: 'NOC_MNG', name: 'مدیر NOC' },
      { value: 'NOC_SUP', name: 'سرپرست NOC' },
      { value: 'OFFICE_MNG', name: 'مدیر اداری' },
      { value: 'OFFICE_OFC', name: 'کارشناس اداری' },
      { value: 'OFFICE_SUP', name: 'سرپرست اداری' },
      { value: 'PERSONNEL', name: 'کارمند' },
      { value: 'PURCHASE_MNG', name: 'مسئول خرید' },
      { value: 'PURCHASE_OFC', name: 'کارشناس خرید' },
      { value: 'PURCHASE_SUP', name: 'سرپرست خرید' },
      { value: 'RESELLER', name: 'همکار فروش' },
      { value: 'RESELLER_INSTALLER', name: 'نصاب همکار فروش' },
      { value: 'SALES_DEDICATE_OFC', name: 'کارشناس فروش اختصاصی' },
      { value: 'SALES_MNG', name: 'مدیر فروش' },
      { value: 'SALES_OFC', name: 'کارشناس فروش' },
      { value: 'SALES_SUP', name: 'سرپرست فروش' },
      { value: 'SLM_OFC', name: 'کارشناس پشتیبانی حضوری' },
      { value: 'SLM_SUP', name: 'سرپرست پشتیبانی حضوری' },
      { value: 'SOFTWARE_DEV', name: 'کارشناس توسعه نرم افزار' },
      { value: 'SOFTWARE_MNG', name: 'مدیر نرم افزار' },
      { value: 'SOFTWARE_QA', name: 'کنترل کیفیت نرم افزار' },
      { value: 'USER', name: 'کاربر' },
      { value: 'WAREHOUSE_MNG', name: 'مدیر انبار' },
      { value: 'WAREHOUSE_OFC', name: 'انباردار' },
      { value: 'WAREHOUSE_SUP', name: 'سرپرست انبار' },
      { value: 'SALES_CONSUTANT', name: 'مشاور فروش' },
      { value: 'PASSIVE_SUP', name: 'سرپرست پسیو' },
      { value: 'TREASURER', name: 'خزانه دار' },
      { value: 'SALES_ACCOUNTANT', name: 'حسابدار فروش' },
      { value: 'GENERAL_ACCOUNTANT', name: 'حسابدار انبار' },

    ];
  }

  @Input() entity: string;
  @Input() subentity: string;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() pkey: string = 'id';
  @Input() views: string[] = ['GRID', 'CARD'];
  @Input() searchable: boolean;
  @Input() limit: number = 100;
  @Input() skip: number = null;
  defaultLimit: number = 100;
  params;
  warnings: [];
  cardPage = 1;
  cardPageSize = 20;
  filters: any;
  allRoles: any;
  shareView = false;
  filterFields = [];
  chartType = 'line';
  customOperations: [{
    name: '>',
    caption: 'بزرگتر از',
    icon: 'greater',
    dataTypes: 'string'
  }, {
    name: '>=',
    caption: 'بزرگتر یا مساوی',
    icon: 'greaterorequal',
    dataTypes: 'string'
  }, {
    name: '<',
    caption: 'کوچکتر از',
    icon: 'less',
    dataTypes: 'string'
  }, {
    name: '<=',
    caption: 'کوچکتر یا مساوی',
    icon: 'lessorequal',
    dataTypes: 'string'
  }];

  graphData = [];
  graphLabel = [];
  graphOption: any = {
    responsive: true,
    maintainAspectRatio: false,
    title: {
      display: false
    },
    scales: {
      yAxes: [{
        ticks: {
          beginAtZero: false
        }
      }],
      xAxes: [{
        ticks: {
          minRotation: 90
        }
      }]
    }
  };

  mapOptions = {
    layers: [tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; Petiak System'
    })],
    zoom: 13,
    center: latLng([35.783644, 51.440329])
  };

  layersControl = {
    baseLayers: {
      'Open Street Map':
        tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; Petiak System' }),
      'Wikimedia': tileLayer('https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png', { maxZoom: 18, attribution: '&copy; Petiak System' })
    }
  };
  searchInput = false;
  layers: any = [];
  public data: any;
  allData: any;
  columns = [];
  actions = [];
  customActions = [];
  body: any = {
    limit: this.limit,
    skip: this.skip
  };
  columnSort: string;
  sortOrder: number;
  rowsActions: any = [];
  primaries: any = [];
  secondaries: any = [];
  trivials: any = [];
  form: any;
  filter: any = { query: null };
  subscription: Subscription;
  createAndEditField: string;
  exportAllowed = false;
  importAllowed = false;

  component: any;
  createAllowed = false;
  loadingEdit = false;
  view: string;
  options: any = {
    header: true,
    title: true, // in modal mode must be false
    search: true
  };
  loading = false;
  selectedRows: any;
  autoExpandAll = false;
  refreshInterval = null;
  refreshTime = 0;
  // the copy affordance currently showing its "copied" check, and the timer
  // that will clear it -- see flashCopied()
  copyFlashTarget: HTMLElement = null;
  copyFlashTimer = null;
  copyFlashTitle = null;
  filterValue = '';
  // reused by cardDate() below, which runs once per card value on every check
  private dateFormatter = new DateformaterPipe();
  columnChooserCheck = false;
  columnChooserAccess = false;
  lastLoadTimestamp;
  collapsedRows: string[] = [];
  searchData = {};
  searchFields = [];
  hasDetail = false;
  gridHeightDefault = 'calc(100vh - 185px)';
  gridHeight = this.gridHeightDefault;
  unlimitedable: boolean = false;
  autorefreshable: boolean = false;
  sortable: boolean = false;
  formSize = 'lg';
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;
  @ViewChild(DxTreeListComponent) dataTree: DxTreeListComponent;
  @ViewChild(DxFilterBuilderComponent) filterBuilder: DxFilterBuilderComponent;
  @ViewChild('header') header;
  @ViewChild('info') info;
  orderby;
  desc;
  map;
  meta: any;
  primary: any;
  amount;
  accountField = 'account_id';
  userField = 'username';
  dsPivot;
  groups = [];
  loadingVisible = false;
  exportFileName() {
    return this.entity + '-' + moment(new Date()).format('jYYYY/jMM/jDD HH:mm:ss');
  }

  async ngOnInit() {
    try {
      await super.ngOnInit();
      this.meta = await this.getMeta();
      if (this.meta.pivot) {
        for (const f of this.meta.pivot) {
          switch (f.pipe) {
            case 'bytes':
              f.format = this.formatBytes
              break;
            case 'number':
              f.format = this.formatNumber
              break;
            case 'money':
              f.format = this.formatMoney
              break;
            case 'timeLength':
              f.format = this.formatSeconds
              break;
            case 'timeLengthMinute':
              f.format = this.formatMinutes
              break;
            default:
              break;
          }
        }
      }
      this.pageTitle = `${this.selectedAccount ? this.selectedAccount : this.translator.instant('APP_NAME')} :: ${this.meta.caption || ''}`;
      this.views = this.meta.views || this.views;
      this.columns = this.meta.columns;
      this.columns.filter(c => ['translate', 'translateByComma', 'template', 'link', 'date', 'datetime'].includes(c.pipe)).forEach(c => {
        c.template = `${c.pipe}Template`;
      });
      this.actions = this.meta.actions;
      this.groups = this.columns.filter(c => c.grouping);

      this.pkey = this.meta.pkey || 'id';
      const createAction = this.actions.find(a => a.name === 'create');
      this.createAllowed = this.form && createAction;
      this.formSize = createAction ? createAction.size || this.formSize : this.formSize;
      this.exportAllowed = this.actions.find(a => a.name === 'export');
      this.importAllowed = this.actions.find(a => a.name === 'import');

      this.searchable = this.actions.find(a => a.name === 'search');
      const nolimitAction = this.actions.find(a => a.name === 'nolimit');
      this.unlimitedable = nolimitAction;
      this.defaultLimit = this.limit = nolimitAction && nolimitAction.default !== undefined ? nolimitAction.default : 100;
      this.autorefreshable = this.actions.find(a => a.name === 'autorefresh');
      const pkeyColumn = this.columns.find(c => c.name === this.pkey);
      this.primary = this.columns.find(c => c.primary);
      const sortAction = this.actions.find(a => a.name === 'sort');
      this.sortable = sortAction;
      this.orderby = this.columns.find(c => c.name === (sortAction ? sortAction.default || this.pkey : this.pkey)) || pkeyColumn;
      this.desc = this.sortable ? sortAction.desc || true : true;
      this.view = this.isMobile ? 'CARD' : localStorage.getItem(`${this.entity}${this.subentity || ''}_view`) || this.views[0];
      this.customActions = this.actions.filter(a => a.primary);
      this.filterFields = this.columns.filter(i => i.filter).map(i => {
        const obj = i.filter;
        // filter.field filters on a raw column (e.g. sms.status codes) while
        // the grid still shows the localized label.
        obj.dataField = i.filter.field || (i.pipe !== 'localize' ? i.name : i.name + '_' + this.lang);
        if (!i.filter.lookup && !i.filter.dataType && !i.filter.options) {
          obj.dataType = 'string';
        }
        obj.caption = i.caption || i.label || i.name;
        return obj;
      });

      this.searchFields = this.columns.filter(i => i.filter && i.visible && !i.filter.advanced).map(i => {
        const obj = i.filter;
        obj.dataField = i.filter.field || (i.pipe !== 'localize' ? i.name : i.name + '_' + this.lang);
        if (!i.filter.lookup && !i.filter.dataType && !i.filter.options) {
          obj.dataType = 'string';
        } else if (i.filter.dataType) {
          obj.dataType = i.filter.dataType;
          obj.format = i.filter.format;
        }
        obj.caption = i.caption;
        return obj;
      });

      this.applySearch();
      if (this.searchable) {
        this.loadFilter();
      }

      if (this.header) {
        this.style();
      }
    } catch (error) {
      console.error(error);
      this.handleError(error);
    }
  }

  style() {
    let top = 0;
    setTimeout(() => {
      $('.header-stick').css({
        position: 'static',
        width: '100%'
      });
      top = $('.header-stick').offset().top;
      $('.navbar-toggler, .sidebar-minimizer').click(function () {
        const currentScroll = $(window).scrollTop(); // get current position

        if (currentScroll >= top) {
          setTimeout(() => {
            $('.header-stick').css({
              width: $('.card-width').width()
            });
          }, 250);
        }
      });
    }, 500);

    // if (this.isMobile) {
    //   if (this.views.indexOf('CARD') === -1) {
    //     this.views.push('CARD');
    //   }
    //   if (!localStorage.getItem(`${this.title}_view`)) {
    //     this.view = 'CARD';
    //   }
    // } else {
    //   this.isMobile = false;
    // }
    $(window).scroll(function () {
      const currentScroll = $(window).scrollTop();
      if (currentScroll >= top) {
        $('.header-stick').css({
          position: 'fixed',
          top: $('.app-header').height(),
          width: $('.card-width').width()

        });
      } else {
        $('.header-stick').css({
          position: 'static',
          width: '100%'

        });
      }

    });
  }

  initializeBody() {
    this.filter['query'] = null;
    // this.applySearch();
  }

  getFormData() {
    return {};
  }

  create(params?) {
    if (this.form) {
      // if (!params && this.params) {
      //   Object.assign(params, this.params);
      // }
      const create = this.activeModal.open(this.form, { size: this.formSize, backdrop: 'static', keyboard: false });
      create.componentInstance.params = params;
      create.componentInstance.formData = this.getFormData();
      create.componentInstance.entityName = this.entity;
      create.componentInstance.subentityName = this.subentity || '';
      create.result.then((result) => {
        if (result) {
          this.load();
        }
      });
    }
  }

  edit(row: any) {
    if (this.form) {
      const edit = this.activeModal.open(this.form, { size: this.formSize, backdrop: 'static', keyboard: false });
      edit.componentInstance.entityName = this.entity;
      edit.componentInstance.isEdit = true;
      edit.componentInstance.pkey = this.pkey;
      edit.componentInstance.id = row[this.pkey];
      edit.result.then(result => {
        if (result) {
          this.load(row[this.pkey]);
        }
      });
    }
  }

  applySearch() {
    this.data = [];
    this.skip = 0;
    if (this.dataGrid && this.dataGrid.instance) {
      this.dataGrid.instance.clearFilter();
    }
    this.load();
  }

  newFilter() {
    if (this.filter['id']) {
      this.filter = {
        name: '',
        query: null,
        id: null
      };
    } else {
      this.filter['name'] = '';
    }

  }

  updateQuery(e) {
    // if (JSON.stringify(e.value) !== JSON.stringify(e.previousValue)) {
    //   this.filter.query = e.component.getFilterExpression();
    // }
  }

  clearFilter() {
    this.filter = { query: null };
    this.searchData = {};
    this.limit = this.defaultLimit;
    this.applySearch();
  }

  changeLimit(limit, holder) {
    this.limit = limit;
    this.skip = 0;
    if (holder === 'list') {
      this.load();
    }
  }

  changeFilter(filter) {
    this.filter = filter;
    // this.filter['actions'] = filter.actions.map(i => i.name || i);
    this.filter['query'] = typeof filter.query === 'string' ? JSON.parse(filter.query) : filter.query;
    this.limit = filter.limit;
    // this.filter['roles'] = [];
    // this.service.apiCall('api/search/getShareRole', { id: filter.id }).subscribe((result2: any) => {
    //   if (result2.json()[0].id) {
    //     this.filter['roles'] = result2.json()[0].id.split(',');
    //   }
    // });

    this.applySearch();
  }

  filterNameChanged(event) {
    delete this.filter['id'];
  }

  deleteFilter() {
    this.service.apiCall('api/search/delete', { id: this.filter['id'] }).subscribe((result: any) => {
      this.filter['query'] = null;
      this.filter = {};
      this.applySearch();
      this.filters = null;
      this.loadFilter();
    }, error => {
      this.handleError(error);
    });
  }

  changeShareView(target) {

    // this.service.apiCall('api/search/share', { id: this.filter['id'], roles: this.filter['roles'] }).subscribe((result: any) => {
    // }, error => {
    //   this.handleError(error);
    // });
  }

  saveFilter(source?, entity = this.entity) {
    if (JSON.stringify(this.searchData) !== '{}') {
      this.filter.query = [];

      this.filterFields.forEach(field => {
        const from = this.searchData[field.dataField + '_from'];
        const to = this.searchData[field.dataField + '_to'];
        switch (field.dataType) {
          case 'number':
            if (from) {
              if (this.filter.query.length > 0) { this.filter.query.push('and'); }
              this.filter.query.push([field.dataField, '>=', from]);
            }

            if (to) {
              if (this.filter.query.length > 0) { this.filter.query.push('and'); }
              this.filter.query.push([field.dataField, '<=', to]);
            }
            break;
          default:
            switch (field.format) {
              case 'time':
                if (from) {
                  if (this.filter.query.length > 0) { this.filter.query.push('and'); }
                  this.filter.query.push([field.dataField, '>=', from]);
                }

                if (to) {
                  if (this.filter.query.length > 0) { this.filter.query.push('and'); }
                  this.filter.query.push([field.dataField, '<', to]);
                }
                break;
              case 'date':
              case 'datetime':
                if (from && from !== '    /  /' && from !== '    /  /   :  ') {
                  let fromQ;
                  if (this.filter.query.length > 0) { this.filter.query.push('and'); }
                  if (source === 'simple') {
                    switch (field.format) {
                      case 'time':
                        fromQ = (typeof (from) === 'string' ? moment(from, 'jYYYY-jMM-jDD HH:mm:ss') : from).locale('en').format('HH:mm');
                        break;
                      case 'date':
                        fromQ = (typeof (from) === 'string' ? moment(from, 'jYYYY-jMM-jDD HH:mm:ss') : from).locale('en').format('YYYY-MM-DD');
                        break;
                      case 'datetime':
                        fromQ = (typeof (from) === 'string' ? moment(from, 'jYYYY-jMM-jDD HH:mm:ss') : from).locale('en').format('YYYY-MM-DD HH:mm:ss');
                        break;
                      default:
                        break;
                    }
                    this.filter.query.push([field.dataField.replace('_fa', '_en'), '>=', fromQ]);
                  } else {
                    this.filter.query.push([field.dataField, '>=', from]);
                  }
                }

                if (to && to !== '    /  /' && to !== '    /  /   :  ') {
                  let toQ;
                  if (this.filter.query.length > 0) { this.filter.query.push('and'); }
                  if (source === 'simple') {
                    switch (field.format) {
                      case 'time':
                        toQ = (typeof (to) === 'string' ? moment(to, 'jYYYY-jMM-jDD HH:mm:ss') : to).locale('en').format('HH:mm');
                        break;
                      case 'date':
                        toQ = (typeof (to) === 'string' ? moment(to, 'jYYYY-jMM-jDD HH:mm:ss') : to).locale('en').format('YYYY-MM-DD');
                        break;
                      case 'datetime':
                        toQ = (typeof (to) === 'string' ? moment(to, 'jYYYY-jMM-jDD HH:mm:ss') : to).locale('en').format('YYYY-MM-DD HH:mm:ss');
                        break;
                      default:
                        break;
                    }
                    this.filter.query.push([field.dataField.replace('_fa', '_en'), '<', toQ]);
                  } else {
                    this.filter.query.push([field.dataField, '<', to]);
                  }
                }
                break;

              default:
                const element = this.searchData[field.dataField];
                if (element) {
                  if (this.filter.query.length > 0) { this.filter.query.push('and'); }
                  if (field.type === 'select' || field.lookup) {
                    this.filter.query.push([field.dataField, '=', `${element}`]);
                  } else {
                    this.filter.query.push([field.dataField, 'contains', this.meta.database == 'mongo' ? element : `%${element}%`]);
                  }
                }
                break;
            }
            break;
        }
      });

    }
    if (this.filter['name']) {
      const name = this.filter['name'];
      const filterApi = !this.filter['id'] ? 'api/search/create' : 'api/search/update';

      this.service.apiCall(filterApi, {
        id: this.filter['id'],
        name: this.filter['name'],
        entity,
        query: this.filter['query'],
        roles: this.filter['roles'],
        limit: this.limit
      }).subscribe((filter: any) => {
        this.handleSuccess();
        this.filter.id = filter.insertId || this.filter.id;
        this.filter.created_by = filter.insertId ? this.username : this.filter.created_by;
      }, error => {
        this.handleError(error);
      });
    }
    this.applySearch();
  }

  open(content) {
    this.activeModal.open(content, { size: 'lg' }).result.then((result) => {
    }, (error) => {
      if (error) {
        this.handleError(error);
      }
    });
  }

  loadFilter() {
    this.service.apiCall('api/search/read', { query: ['entity', '=', this.entity] }).subscribe((filters: any) => {
      this.filters = filters;
      this.filters.forEach(filter => {
        if (filter.roles) {
          filter.roles = filter.roles.split(',');
        }
      });
    }, error => {
      this.handleError(error);
    });
  }

  load(key?, query?) {
    this.loading = true;
    this.lastLoadTimestamp = (+new Date()).toString();
    this.service.apiCall(this.getApi(), this.getBody(), this.lastLoadTimestamp).subscribe((result: any) => {
      if (key && this.dataGrid) { this.reselect(key); }
      this.loading = false;
      this.handleResult(result);
      // if (result.ok && result.headers.get('timestamp') === this.lastLoadTimestamp) {
      //   if (key && this.dataGrid) { this.reselect(key); }
      //   this.loading = false;
      //   this.handleResult(result);
      // } else {
      //   this.loading = false;
      // }
      return;
    }, error => {
      this.loading = false;
      this.handleError(error);
      return;
    });
  }

  getApi(): string {
    return `api/${this.entity.toLocaleLowerCase()}/read`;
  }

  getBody(): any {
    return {
      path: this.entity,
      limit: this.limit,
      skip: this.skip,
      mode: 'list',
      fields: this.columns && this.columns.length ?
        this.columns.map(c => c.pipe !== 'localize' ? c.name : `${c.name}_${this.lang}`) : undefined,
      query: this.filter['query'],
      orderby: this.orderby ? this.orderby.pipe === 'localize' ? `${this.orderby.name}_${this.lang}` : this.orderby.name : undefined,
      desc: this.desc
    };
  }

  getActions(row: any): [] {
    return row.actions ? row.actions : [];
  }

  getMeta(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.entity) {
        const key = `list_${this.entity.toLowerCase()}_${(this.subentity || '').toLowerCase()}`;
        const cached = sessionStorage.getItem(key);
        if (false && cached) {
          resolve(JSON.parse(cached));
        } else {
          this.service.list(
            this.entity.toLowerCase(),
            (this.subentity || '').toLowerCase()
          ).subscribe((result: any) => {
            sessionStorage.setItem(key, JSON.stringify(result));
            resolve(result);
          }, error => {
            console.error(error);
            reject(error);
          });
        }

      } else {
        reject('Entity is not specified.');
      }
    });
  }

  getMarker(i) {
    const markr = marker([i.latitude, i.longitude], {
      title: this.primary ? i[this.primary.name] : i[this.pkey],
      riseOnHover: true,
      icon: icon({
        iconUrl: `assets/images/leaflet/marker.png`,
        iconSize: [24, 24]
      })
    });
    return markr;
  }

  async handleResult(result) {
    return new Promise((resolve, reject) => {
      try {
        if (result && result[0] && result[0][0]) {
          this.data = result[0];
        } else {
          this.data = result;
        }
        if (this.columnSort) {
          this.changeSort(this.columnSort, this.sortOrder);
        }
        if (this.filterValue && this.filterValue.length) {
          this.data = this.data.filter(v => {
            return Object.values(v).join('|').toLowerCase().includes(this.filterValue.toLowerCase());
          });
        }
        if (this.views.indexOf('MAP') !== -1) {
          this.layers = this.data.filter(i => i.latitude && i.longitude).map(i => this.getMarker(i));
        }
        if (this.views.indexOf('GRAPH') !== -1) {

          if (!this.columnSort) {
            this.changeSort(this.columns.filter(i => i.xaxis)[0].name, 1);
          }
          this.chartGenerate();
        }
        if (this.data) {
          this.data.forEach(element => {
            element.actions = this.getActions(element);
          });
        }
        this.allData = this.data;
        resolve(true);
      } catch (error) {
        reject(error);
      }
    });
  }

  chartGenerate = () => {
    const yaxisColumns = this.columns.filter(i => i.yaxis).map(ii => ({ name: ii.name, label: ii.label, pipe: ii.pipe }));
    this.graphData = [];
    this.graphLabel = [];
    const x = this.columns.filter(i => i.xaxis)[0];

    this.translator.get(yaxisColumns.map(ii => (ii.label || ii.name).toUpperCase())).subscribe(translateResult => {

      yaxisColumns.forEach((yCol) => {
        if (!this.graphData.find(i => i.label === yCol.name)) {
          this.graphData.push({
            data: this.data.map(i => {
              if (yCol.pipe === 'gig') {
                return new GigPipe().transform(i[yCol.name]);
              } else {
                return i[yCol.name];
              }
            }).slice((this.cardPage - 1) * this.cardPageSize,
              this.cardPage * this.cardPageSize),
            label: translateResult[(yCol.label || yCol.name).toUpperCase()]
          });

        }
      });

    });

    this.graphLabel = this.data.map(i => {
      if (x.pipe === 'datetime') {
        return new DateformaterPipe().transform(i[x.name]);
      } else {
        return i[x.name];
      }
    }).slice((this.cardPage - 1) * this.cardPageSize, this.cardPage * this.cardPageSize);
  }

  next() {
    this.skip += this.limit;
    this.body.skip = this.skip;
    this.load();
  }

  previous() {
    if (this.skip >= this.limit) {
      this.skip -= this.limit;
      this.body.skip = this.skip;
      this.load();
    }
  }

  onToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'revert', onClick: () => {
          localStorage.removeItem(`${this.entity}${this.subtitle || ''}_grid`);
          const key = `list_${this.entity.toLowerCase()}_${(this.subentity || '').toLowerCase()}`;
          sessionStorage.removeItem(key);
          // window.location.reload();
          this.dataGrid.instance.clearGrouping();
          this.dataGrid.instance.clearFilter();
          this.dataGrid.instance.clearSelection();
          this.dataGrid.instance.clearSorting();
          // this.ngOnInit();
        }
      }
    });
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'expand',
        onClick: () => {
          this.gridHeight === 'unset' ? this.gridHeight = this.gridHeightDefault : this.gridHeight = 'unset';
        }
      }
    });

    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'info', onClick: () => {
          this.showInfo();
        }
      }
    });

  }

  /**
   * The toolbar's info button shows the selected row as a card.
   *
   * #info renders the carditem template, which is guarded by *ngIf="row", so
   * with nothing selected it opened a modal with an empty body and no way to
   * tell why. Say what is missing instead of showing that.
   */
  showInfo() {
    if (!this.selectedRows || !this.selectedRows.length) {
      this.handleWarning(this.translator.instant('SELECT_ROW_FIRST'));
      return;
    }
    this.activeModal.open(this.info);
  }

  onTreeToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'revert', onClick: () => {
          localStorage.removeItem(`${this.entity}${this.subtitle || ''}_tree`);
          const key = `list_${this.entity.toLowerCase()}_${(this.subentity || '').toLowerCase()}`;
          sessionStorage.removeItem(key);
          this.dataTree.instance.clearFilter();
          this.dataTree.instance.clearSelection();
          this.dataTree.instance.clearSorting();
          // this.ngOnInit();
        }
      }
    });
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'info', onClick: () => {
          this.showInfo();
        }
      }
    });
    e.toolbarOptions.items.unshift({
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'chevrondown', onClick: () => {

          this.data.map(item => item.id).forEach(element => {
            this.dataTree.instance.expandRow(element);
          });

        }
      }
    }, {
      location: 'after',
      widget: 'dxButton',
      options: {
        icon: 'chevronright', onClick: () => {

          this.data.map(item => item.id).forEach(element => {
            this.dataTree.instance.collapseRow(element);
          });

        }
      }
    });

  }

  reselect(key) {
    if (this.dataGrid) {
      this.dataGrid.instance.clearSelection();
      setTimeout(() => {
        this.dataGrid.instance.selectRows(key, false);
      }, 200);
    }
  }

  onSelectionChanged(e) {
    this.selectedRows = e.selectedRowsData;
    this.rowsActions = this.getRowsActions(this.selectedRows);
    this.primaries = this.rowsActions.filter(a => a.primary);
    this.secondaries = this.rowsActions.filter(a => a.secondary);
    this.trivials = this.rowsActions.filter(a => !a.primary && !a.secondary);
    if (this.trivials.length === 1) {
      this.trivials[0].secondary = true;
      this.secondaries = this.rowsActions.filter(a => a.secondary);
      this.trivials = this.rowsActions.filter(a => !a.primary && !a.secondary);
    }
  }

  onRowExpanding($event) {
    if (this.autoExpandAll) {
      this.collapsedRows = this.collapsedRows.filter(obj => obj.toString() !== $event.key.toString());
    }
  }

  onRowCollapsing($event) {
    if (this.autoExpandAll) {
      this.collapsedRows.push($event.key);
    }
  }

  onContentReady($event) {
    if (this.autoExpandAll) {
      for (let i = 0; i < this.collapsedRows.length; i++) {
        $event.component.collapseRow(this.collapsedRows[i]);
      }
    }
  }

  onRowClick(e) {
    const component = e.component,
      prevClickTime = component.lastClickTime;
    component.lastClickTime = new Date();
    if (prevClickTime && (component.lastClickTime - prevClickTime < 400)) {
      if (!this.roles.includes('CRA')) {
        this.rowDoubleClick(e);
      }
    } else {
      this.rowClick(e);
    }
  }

  rowClick(e) {

  }

  rowDoubleClick(e) {
    if (this.form && this.selectedRows[0].actions && this.selectedRows[0].actions.filter(a => a.name === 'UPDATE').length > 0) {
      this.edit(this.selectedRows[0]);
    } else if ((this.selectedRows[0][this.accountField] || this.selectedRows[0][this.userField])
      && this.username !== this.selectedRows[0][this.accountField]) {
      this.chooseUser(this.selectedRows[0]);
    }
  }

  getRowsActions(selectedRows) {
    if (selectedRows.length) {
      let rowsActions = selectedRows[0].actions.slice();
      if (this.selectedRows.length > 1) {
        rowsActions = rowsActions.filter(a => a.group);
        for (let index = 1; index < selectedRows.length; index++) {
          const element = selectedRows[index];
          rowsActions = rowsActions.filter(a => element.actions.find(b => b.name === a.name));
        }
      }

      if (rowsActions.length &&
        rowsActions.filter(a => a.secondary).length === 0 &&
        rowsActions.filter(a => !a.secondary && !a.primary).length > 0) {
        rowsActions.filter(a => !a.secondary && !a.primary)[0].secondary = true;
      }
      return rowsActions;
    } else {
      return [];
    }
  }

  viewChanged(view) {
    if (view !== 'GRID') {
      this.selectedRows = [];
      this.rowsActions = [];
      this.primaries = [];
      this.secondaries = [];
      this.trivials = [];
    }
    localStorage.setItem(`${this.entity}${this.subentity || ''}_view`, this.view);
    if (view === 'CARD' && this.limit > 20) {
      this.limit = 20;
      this.load();
    }
  }

  setLocation(row: any, loc: any) {
    return new Promise((resolve, reject) => {
      resolve(true);
    });
  }

  async prepare(action, rows) {
    if (action.component) {
      let modal;
      let form;
      switch (action.component.toLowerCase()) {
        case 'comment':
          form = this.activeModal.open(CommentFormComponent, { size: 'lg', backdrop: 'static', keyboard: false });
          form.componentInstance.title = action.caption;
          form.componentInstance.done.subscribe(async res => {
            form.close();
            let hasError = false;
            for (const row of rows) {
              try {
                row.data = {
                  comment: res.value
                };
                await this.perform(action, row);
              } catch (error) {
                hasError = true;
                this.handleError(error);
              }
            }
            if (!hasError) {
              this.handleSuccess();
            }
            if (action.reload) {
              this.load(rows.length ? rows[0][this.pkey] : undefined);
            }

          }, error => {
            form.componentInstance.loading = false;
            this.handleError(error);
          });
          break;
        case 'confirm':
          const dialog = custom({
            title: action.caption,
            message: action.message || this.translator.instant('CONFIRM_ACTION', { action: action.caption, count: rows.length }),
            buttons: [{
              text: this.translator.instant('YES'), onClick: function () {
                return true;
              }
            }, {
              text: this.translator.instant('NO'), onClick: function () {
                return false;
              }
            }]
          });
          dialog.show().done(async result => {
            if (result) {
              let hasError = false;
              for (const row of rows) {
                try {
                  await this.perform(action, row);
                } catch (error) {
                  hasError = true;
                  this.handleError(error);
                }
              }
              if (!hasError) {
                this.handleSuccess();
              }
              if (action.reload) {
                this.load(rows.length ? rows[0][this.pkey] : undefined);
              }
            } else {
              dialog.hide();
            }
          });
          break;
        case 'locator':
          modal = this.activeModal.open(LocatorComponent, { size: 'lg' });
          modal.componentInstance.row = rows[0];
          modal.componentInstance.done.subscribe((loc) => {
            this.setLocation(rows[0], loc).then(result => {
              modal.close();
            }).catch(error => {
              this.handleError(error);
            });
          });
          break;

        default:
          if (!this.production) {
            console.log('Component handler not found for', action);
          }
          for (const row of rows) {
            await this.perform(action, row);
          }
          if (action.reload) {
            this.load(rows.length ? rows[0][this.pkey] : undefined);
          }
          this.handleSuccess();
          break;
      }
    } else {
      for (const row of rows) {
        await this.perform(action, row);
      }
      if (action.reload) {
        this.load(rows.length ? rows[0][this.pkey] : undefined);
      }
      this.handleSuccess();
    }
  }

  async perform(action, row) {
    return new Promise(async (resolve, reject) => {
      try {
        switch (action.name.toLowerCase()) {
          case 'choose':
            if ((row[this.accountField] || row[this.userField]) && this.username !== row[this.accountField]) {
              this.chooseUser(row);
              resolve(true);
            }
            break;
          case 'update':
            this.edit(row);
            break;
          case 'open_map':

            const lat = row.lat || row.data?.lat;
            const lon = row.lon || row.data?.lon;
            if (lat && lon) {
              if (this.isMobile) {
                window.open(`geo:${lat},${lon}`, `${lat},${lon}`)
              } else {
                window.open(`https://www.google.com/maps/search/?api=1&query=${lat}%2C${lon}`, `${lat},${lon}`)
              }
            }
            break;
          default:
            await this.service.perform(this.entity, action.name, row).toPromise();
            resolve(true);
            break;
        }
      } catch (error) {
        this.handleError(error);
        reject(error);
      }
    });
  }

  autoRefresh(time) {
    this.refreshTime = time;
    time = time * 1000;

    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    if (time) {
      this.refreshInterval = setInterval(() => {
        this.load();
      }, time);
    }
  }

  ngOnDestroy() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    if (this.copyFlashTimer) {
      clearTimeout(this.copyFlashTimer);
    }
  }

  filterData(event) {
    this.filterValue = event.target.value;
    if (this.filterValue.length) {
      this.data = this.allData.filter(v => {
        return Object.values(v).join('|').toLowerCase().includes(this.filterValue.toLowerCase());
      });
    } else if (this.data.length !== this.allData.length) {
      this.data = this.allData;
    }
    if (this.view === 'MAP') {
      this.layers = this.data.filter(i => i.latitude && i.longitude).map(i => this.getMarker(i));
    }
  }

  cardPaginatin(page) {
    this.cardPage = page;
    if (this.view === 'GRAPH') {
      this.chartGenerate();
    }
  }

  changeSortDb(col, order, holder) {
    this.orderby = col;
    this.desc = order;
    if (holder === 'list') {
      this.load();
    }
  }

  changeSort(col, order) {
    this.sortOrder = order;
    this.columnSort = col;
    this.data.sort((a, b) => {
      if (!a[col] && !b[col]) {
        return 0;
      } else if (!a[col]) {
        return -1 * order;
      } else if (!b[col]) {
        return order;
      } else if (a[col] > b[col]) {
        return order;
      } else if (a[col] < b[col]) {
        return -1 * order;
      } else {
        return 0;
      }
    });

    if (this.view === 'GRAPH') {
      this.chartGenerate();
    }
  }

  closeModal() {
  }

  numberFormat(data) {
    return data.valueText.replace(data.value, data.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));;
  }

  bytesFormat(data) {
    return data.valueText.replace(data.value, new BytesPipe().transform(data.value));
  }

  moneyFormat(data) {
    return data.valueText.replace(data.value, new MoneyPipe().transform(Math.round(data.value)));
  }

  timeLengthFormat = (data) => {
    return this.formatSeconds(data.value)
  }

  timeLengthMinuteFormat(data) {
    return data.valueText.replace(data.value, new MinuteToTimeStructuredPipe().transform(data.value));
  }

  onMapReady(map: Map) {
    this.map = map;
  }

  mapClick(event) {
  }

  getCardHeaderStyle(row) {
    return {};
  }

  async chooseUser(row) {
    try {
      const oldSelectedAccount = sessionStorage.getItem('selectedAccount');
      const oldSelectedUser = sessionStorage.getItem('selectedUser');
      let account = row[this.accountField];
      const user = row[this.userField];
      if (user) {

        if (!account) {
          const result = await this.service.perform('user', 'read', { username: user, fields: ['account_id'] }).toPromise();
          account = result[0].account_id;
        }

        let w = window.open('/', '_blank');
        try {
          const worklog = await this.service.apiCall('api/work_log/create', { account_id: account, user_id: row[this.userField] }).toPromise();
          // PostgreSQL does not return MySQL's `insertId`; /:entity/create answers
          // with the pg result object, so the new row's key is rows[0].id. Reading
          // .insertId yielded undefined, and sessionStorage.setItem stringifies --
          // storing the literal text "undefined", which is truthy, so deleteLog()
          // skipped its fallback lookup and posted { id: "undefined" } to the API.
          const newWorkLogId = worklog?.rows?.[0]?.id;
          if (newWorkLogId) {
            w.sessionStorage.setItem('workLogId', String(newWorkLogId));
          }
        } catch (error) {

        }
        w.sessionStorage.setItem('selectedAccount', account);
        w.sessionStorage.setItem('selectedUser', user);
        // if (oldSelectedAccount) {
        //   sessionStorage.setItem('selectedAccount', oldSelectedAccount);
        //   sessionStorage.setItem('selectedUser', oldSelectedUser);
        // } else {
        //   sessionStorage.removeItem('selectedAccount');
        //   sessionStorage.removeItem('selectedUser');
        // }
      } else if (account) {
        let w = window.open('/', '_blank');
        try {
          const worklog = await this.service.apiCall('api/work_log/create', { account_id: account }).toPromise();
          // PostgreSQL does not return MySQL's `insertId`; /:entity/create answers
          // with the pg result object, so the new row's key is rows[0].id. Reading
          // .insertId yielded undefined, and sessionStorage.setItem stringifies --
          // storing the literal text "undefined", which is truthy, so deleteLog()
          // skipped its fallback lookup and posted { id: "undefined" } to the API.
          const newWorkLogId = worklog?.rows?.[0]?.id;
          if (newWorkLogId) {
            w.sessionStorage.setItem('workLogId', String(newWorkLogId));
          }
        } catch (error) {

        }
        w.sessionStorage.setItem('selectedAccount', account);
        // if (oldSelectedAccount) {
        //   sessionStorage.setItem('selectedAccount', oldSelectedAccount);
        // } else {
        //   sessionStorage.removeItem('selectedAccount');
        // }
      }
    } catch (error) {
      this.handleError(error);
    }
  }

  sizeFormat(e) {
    return this.formatBytes(e.value);
  }

  async import() {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.xlsx,.xls,.csv';

    input.onchange = async (event: any) => {
      try {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();

        // Check if it's a CSV file
        if (file.name.endsWith('.csv')) {
          reader.onload = async (e: any) => {
            try {
              const textData = e.target.result as string;

              // Parse CSV using XLSX (ensures UTF-8 encoding)
              const workbook = XLSX.read(textData, { type: 'string' });

              const sheetName = workbook.SheetNames[0];
              if (!sheetName) throw new Error("The file contains no sheets.");

              const worksheet = workbook.Sheets[sheetName];
              const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
              console.log(jsonData)
              this.processData(jsonData);
            } catch (error) {
              console.error("Error processing CSV file", error);
              alert("Failed to process the CSV file. Please check the encoding.");
            }
          };
          reader.readAsText(file, 'UTF-8'); // Read CSV as UTF-8 text
        } else {
          // For Excel Files (.xlsx, .xls)
          reader.onload = async (e: any) => {
            try {
              const data = new Uint8Array(e.target.result);
              const workbook = XLSX.read(data, { type: 'array' });

              const sheetName = workbook.SheetNames[0];
              if (!sheetName) throw new Error("The file contains no sheets.");

              const worksheet = workbook.Sheets[sheetName];
              const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

              this.processData(jsonData);
            } catch (error) {
              console.error("Error processing Excel file", error);
              alert("Failed to process the Excel file. Please check the format.");
            }
          };
          reader.readAsArrayBuffer(file);
        }
      } catch (error) {
        console.error("File import error", error);
        alert("File import failed.");
      }
    };

    input.click();
  }

  /**
   * Processes the extracted JSON data and inserts it into the data source
   */
  async processData(jsonData: any[]) {
    if (!jsonData.length) {
      alert("The file is empty.");
      return;
    }

    const headers = jsonData[0] as string[];
    const rows = jsonData.slice(1);

    const records = rows.map(row => {
      const record: { [key: string]: any } = {};
      headers.forEach((header, index) => {
        record[header] = row[index] ?? null;
      });
      return record;
    });

    if (records.length) {
      for (const record of records) {
        try {
          await this.service.apiCall(`api/${this.entity.toLocaleLowerCase()}/create`, record).toPromise();
        } catch (error) {
          this.handleError(error)
        }
      }
      this.load();
    }
  }

  /**
   * Copy a card's record id to the clipboard (card view header).
   *
   * navigator.clipboard is only defined in a secure context, which holds over
   * https but not when the app is opened over plain http on a LAN address, so
   * fall back to a detached textarea + execCommand there.
   */
  async copyKey(value, event?: Event): Promise<boolean> {
    // currentTarget is only set while the event is being dispatched and the
    // clipboard write below is awaited, so read the element to flash up front.
    const source = event ? event.currentTarget as HTMLElement : null;
    if (event) {
      event.stopPropagation();
    }
    const text = (value === null || value === undefined) ? '' : String(value);
    if (!text) {
      return false;
    }
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        const area = document.createElement('textarea');
        area.value = text;
        area.setAttribute('readonly', '');
        area.style.position = 'fixed';
        area.style.top = '-1000px';
        area.style.opacity = '0';
        document.body.appendChild(area);
        area.select();
        document.execCommand('copy');
        document.body.removeChild(area);
      }
      this.flashCopied(source);
      return true;
    } catch (error) {
      this.handleError(error);
      return false;
    }
  }

  /**
   * Confirm a copy on the control that was clicked: `.copy-done` swaps the
   * icon to a green check for a moment.
   *
   * A toast for something this small is more interruption than it is worth,
   * and on a card of 20 fields it also covers the next value you were about
   * to copy.
   */
  private flashCopied(element: HTMLElement) {
    if (!element) {
      return;
    }
    // Copying a second value while the first check is still up: drop the old
    // one now, or its timer would strip the class off the new element early.
    if (this.copyFlashTimer) {
      clearTimeout(this.copyFlashTimer);
      this.clearCopyFlash();
    }
    this.copyFlashTarget = element;
    this.copyFlashTitle = element.getAttribute('title');
    element.classList.add('copy-done');
    // The green check is the only cue otherwise, and colour alone is not one.
    element.setAttribute('title', this.translator.instant('COPIED'));
    this.copyFlashTimer = setTimeout(() => {
      this.clearCopyFlash();
      this.copyFlashTimer = null;
    }, 1200);
  }

  private clearCopyFlash() {
    const element = this.copyFlashTarget;
    if (!element) {
      return;
    }
    element.classList.remove('copy-done');
    if (this.copyFlashTitle === null) {
      element.removeAttribute('title');
    } else {
      element.setAttribute('title', this.copyFlashTitle);
    }
    this.copyFlashTarget = null;
    this.copyFlashTitle = null;
  }

  /**
   * Card view: show an undeclared date value in the UI's calendar.
   *
   * Columns whose metadata names a date type already go through dateformater
   * in the template. The rest fall through to the raw value, and a plain
   * `character varying` column holding a timestamp (or an api-built
   * `row.template` entry, which carries no type at all) then shows the
   * gregorian string the API sent. Detect that shape by value and run it
   * through the same pipe, so a Persian UI reads jalali like everything else.
   *
   * Anything that is not an ISO date is returned untouched.
   */
  cardDate(value: any) {
    if (typeof value !== 'string' || !ISO_DATE.test(value)) {
      return value;
    }
    return this.dateFormatter.transform(value, ISO_DATE_ONLY.test(value) ? 2 : 1, this.lang);
  }

  /**
   * Copy a card field's value (card view body).
   *
   * Reads the cell's rendered text rather than the underlying record, so
   * money, dates, byte sizes and translated enums reach the clipboard exactly
   * as they are shown. The alternative would be re-applying every pipe in the
   * template's ngSwitch by hand.
   */
  copyValue(event: MouseEvent) {
    const target = event.target as HTMLElement;
    // a real link should still navigate rather than copy
    if (target && target.closest && target.closest('a')) {
      return;
    }
    // Someone dragging to select part of a long value (an address, say) ends
    // on a click here; copying the whole cell would silently replace what they
    // just selected, so leave a deliberate selection alone.
    const selection = window.getSelection();
    if (selection && selection.toString().trim()) {
      return;
    }
    const cell = event.currentTarget as HTMLElement;
    const text = (cell.innerText || '').replace(/\s+/g, ' ').trim();
    this.copyKey(text, event);
  }

  /**
   * Grid copy-to-clipboard, hover affordance.
   *
   * A plain cell click cannot be used: onRowClick above hand-rolls
   * double-click detection on a 400ms window, so copying on click would fire
   * twice on the way to opening the edit form. The icon is therefore its own
   * click target and stops propagation, leaving the row gestures intact.
   *
   * e.text is DevExtreme's already-formatted display string, so money, dates
   * and lookup columns copy exactly as rendered.
   */
  onCellPrepared(e) {
    if (e.rowType !== 'data' || !e.column || e.column.command) {
      return;
    }
    const text = (e.text || '').trim();
    if (!text) {
      return;
    }
    const cell: HTMLElement = e.cellElement;
    if (!cell || cell.querySelector('.dx-copy-icon')) {
      return;
    }
    cell.classList.add('dx-cell-copyable');

    const icon = document.createElement('i');
    icon.className = 'fa fa-copy dx-copy-icon';
    icon.title = this.translator.instant('COPY');
    icon.addEventListener('click', (event: MouseEvent) => {
      event.preventDefault();
      this.copyKey(text, event);
    });
    cell.appendChild(icon);
  }

  /**
   * Row actions on right-click: the same API metadata the card view renders.
   * Only the primaries sit at the top level, the rest nest under one item, so
   * an 11-action row does not produce an 11-item menu.
   */
  onContextMenuPreparing(e) {
    if (e.target !== 'content' || !e.row || e.row.rowType !== 'data') {
      return;
    }
    e.items = e.items || [];

    // Row actions, the same metadata the card view renders. Right-clicking
    // inside a multi-row selection acts on the whole selection, using the
    // group-capable subset getRowsActions() already works out.
    const row = e.row.data;
    const multi = this.selectedRows && this.selectedRows.length > 1 &&
      this.selectedRows.some(r => r[this.pkey] === row[this.pkey]);
    const targets = multi ? this.selectedRows : [row];
    const actions: any[] = multi ? this.getRowsActions(this.selectedRows) : this.getActions(row);
    if (!actions || !actions.length) {
      return;
    }

    // action.icon is stored without the font-awesome family prefix in places,
    // matching how the card template writes class="fa fa-lg" [ngClass]="action.icon"
    const iconClass = (icon: string) => !icon ? undefined : (icon.indexOf('fa ') === 0 ? icon : `fa ${icon}`);
    const toItem = (action: any, beginGroup = false) => ({
      text: action.caption || action.name,
      icon: iconClass(action.icon),
      beginGroup,
      onItemClick: () => this.prepare(action, targets)
    });

    // A row carries ~11 actions; listing them flat would bury the copy entry,
    // so only the primaries sit at the top level and the rest nest under one
    // item - the same split the card header makes with its gear dropdown.
    const primary = actions.filter(a => a.primary);
    const rest = actions.filter(a => !a.primary);

    primary.forEach((action, i) => e.items.push(toItem(action, i === 0)));
    if (rest.length) {
      e.items.push({
        text: this.translator.instant('OTHERS'),
        beginGroup: !primary.length,
        items: rest.map(action => toItem(action))
      });
    }
  }

}
